export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "scripts/app.Message.worker.75f3bde2743b2a590833.worker.js");
}
